import { render, staticRenderFns } from "./group-column-num.mpx?vue&type=template&id=ab213f14&isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex"
import script from "./group-column-num.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex"
export * from "./group-column-num.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex"
import style0 from "./group-column-num.mpx?vue&type=style&index=0&id=ab213f14&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_0e7767e2%22%7D&isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports